module.exports = __webpack_public_path__ + "static/img/intro-image.dae95e2.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/intro-image.gif
// module id = d4Rs
// module chunks = 0